import { notifications } from "@mantine/notifications";
import get from "lodash/get";
import { useCallback, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { loginPasswordless as loginPasswordlessApi } from "../../api/login.ts";
import Preloader from "../../components/Preloader/Preloader.tsx";
import { AppRoute } from "../../constants.ts";

export const LoginPasswordlessPage = () => {
  const [searchParams] = useSearchParams();
  const tokenParam = searchParams.get("token");

  const navigate = useNavigate();

  const loginPasswordless = useCallback(() => {
    loginPasswordlessApi(tokenParam ?? "")
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        let message = "Something went wrong. Please try again later.";
        if (get(error, "response.status") === 404) {
          message =
            "The login link has expired or has been already used. Please try again later.";
        }
        notifications.show({ message, variant: "error" });
        navigate(AppRoute.Login);
      });
  }, [navigate, tokenParam]);

  useEffect(() => {
    loginPasswordless();
  }, [loginPasswordless]);

  return <Preloader loading={true} />;
};
